<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
               v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item label="品种规格" prop="specName">
              <el-input clearable v-model.trim="formData.specName" placeholder="请输入品种规格" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="manufacturerId" label="生产商">
              <el-select v-model="formData.manufacturerId" clearable filterable placeholder="请选择生产商">
                <el-option v-for="(item, index) of supplierArr" :value="item.materialsId" :label="item.materialsName"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              <el-date-picker v-model="formData.productionDate" placeholder="请选择生产日期" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inspectionDate" label="送检日期">
              <el-date-picker v-model="formData.inspectionDate" placeholder="请选择送检日期" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="issueDate" label="签发日期">
              <el-date-picker v-model="formData.issueDate" placeholder="请选择签发日期" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remark" label="备注">
              <el-input v-model="formData.remark" placeholder="请输入备注" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'TypeQcReportAdd',
  data() {
    return {
      formData: {
        reportId: '',
        productionDate: '',
        specName: '',
        inspectionDate: '',
        issueDate: '',
        manufacturerId: '',
        remark: '',
        fileList: []
      },
      supplierArr: [],
      rules: {
        specName: [
          { required: true, message: '请输入品种规格', trigger: 'blur' }
        ],
        manufacturerId: [
          { required: true, message: '请选择生产商', trigger: ['blur', 'change'] }
        ],
        productionDate: [
          { required: true, message: '请选择生产日期', trigger: ['blur', 'change'] }
        ],
        inspectionDate: [
          { required: true, message: '请选择送检日期', trigger: ['blur', 'change'] }
        ],
        issueDate: [
          { required: true, message: '请选择签发日期', trigger: ['blur', 'change'] }
        ],
        remark: [],
        fileList: []
      },
      loading: false
    }
  },
  created() {
    this.loadSupplier()
    if (this.reportId) {
      this.loadData()
    }
  },
  computed: {
    reportId() {
      return this.$route.query.reportId
    }
  },
  methods: {
    loadSupplier() {
      this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierArr = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.typeQcReport.selectPaTypeQcReportByReportId, {
        params: { reportId: this.reportId }
      }).then(res => {
        this.formData = {
          reportId: res.reportId,
          productionDate: res.productionDate,
          specName: res.specName,
          inspectionDate: res.inspectionDate,
          issueDate: res.issueDate,
          manufacturerId: res.manufacturerId,
          remark: res.remark,
          fileList: res.fileList || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.loading = true
        let url = this.$apis.typeQcReport.insertPaTypeQcReport
        if (this.reportId) {
          url = this.$apis.typeQcReport.updatePaTypeQcReport
        }
        this.$axios.post(url, { ...this.formData }).then(() => {
          this.$router.back()
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input,
  .el-select,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
